import { type } from '@/utils/type'


export const UMBTYPE_REQUEST = type('UMBTYPE_REQUEST')
export const UMBTYPE_SUCCESS = type('UMBTYPE_SUCCESS')
export const UMBTYPE_ERROR = type('UMBTYPE_ERROR')

export const UMBTYPE_ENSURE_LIST = type('UMBTYPE_ENSURE_LIST')

export const UMBTYPE_SELECT_DETAIL_REQUEST = type('UMBTYPE_SELECT_DETAIL_REQUEST')
export const UMBTYPE_SELECT_DETAIL_SUCCESS = type('UMBTYPE_SELECT_DETAIL_SUCCESS')
export const UMBTYPE_SELECT_DETAIL_ERROR = type('UMBTYPE_SELECT_DETAIL_ERROR')
export const UMBTYPE_SELECT_DETAIL = type('UMBTYPE_SELECT_DETAIL')

export const UMBTYPE_SAVE_REQUEST = type('UMBTYPE_SAVE_REQUEST')
export const UMBTYPE_SAVE_SUCCESS = type('UMBTYPE_SAVE_SUCCESS')
export const UMBTYPE_SAVE_ERROR = type('UMBTYPE_SAVE_ERROR')

export const UMBTYPE_UPDATE_MODIFIED_ADM = type('UMBTYPE_UPDATE_MODIFIED_ADM')
export const UMBTYPE_CANCEL_MODIFIED_ADM = type('UMBTYPE_CANCEL_MODIFIED_ADM')

export const UMBTYPE_UPDATE_FILTER_ADM = type('UMBTYPE_UPDATE_FILTER_ADM')